export default __webpack_public_path__ + "static/media/teco_logo.b3589f65.png";